import React from "react"
import HeaderSelect from "../../../../../components/Headers/HeaderSelect"
import {
  useEnterpriseGetOne,
  useMainEnterpriseId,
} from "../../../../../hooks/enterprise"
import Link from "next/link"
import LayoutSelect from "../../../../../components/Layouts/LayoutSelect"
import HeaderSelectTop from "../../../../../components/Headers/HeaderSelectTop"
import { ArrowLeft } from "lucide-react"
import LayoutLoadingAuthRequired from "../../../../../components/Layouts/LayoutLoadingAuthRequired"
import { useShopGetOne, useShopId } from "../../../../../hooks/shop"
import ShopSalePointList from "../../../../../components/ShopSalePoint/ShopSalePointList"

function Index() {
  const enterpriseId = useMainEnterpriseId()
  const shopId = useShopId()

  const {
    enterprise,
    isLoading: isLoadingEnterprise,
    isError: isErrorEnterprise,
  } = useEnterpriseGetOne(enterpriseId)
  const {
    shop,
    isLoading: isLoadingShop,
    isError: isErrorShop,
  } = useShopGetOne(enterpriseId, shopId)

  if (
    isLoadingEnterprise ||
    isLoadingShop ||
    isErrorEnterprise ||
    isErrorShop
  ) {
    return (
      <React.Fragment>
        <LayoutLoadingAuthRequired
          isLoading={isLoadingEnterprise || isLoadingShop}
          isError={isErrorEnterprise || isErrorShop}
        />
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <LayoutSelect title="Выберите точку продажи">
        <HeaderSelectTop>
          <Link
            href={`/e/${enterpriseId}`}
            className="inline-flex items-center rounded-md border border-border bg-card px-4 py-2 text-sm font-medium text-foreground shadow-xs transition-colors hover:bg-muted focus:ring-2 focus:ring-ring focus:outline-none"
          >
            <ArrowLeft
              className="mr-2 size-4 text-muted-foreground"
              aria-hidden="true"
            />
            <span>Назад к выбору магазина</span>
          </Link>
        </HeaderSelectTop>

        <HeaderSelect
          name={shop?.title}
          title={"Выберите точку продаж"}
          subTitle={
            "Данный выбор будет сохранён для простоты работы. Вы всегда сможете вернуться к выбору в разделе настроек"
          }
        />

        <ShopSalePointList />
      </LayoutSelect>
    </React.Fragment>
  )
}

export default Index
